import { action, observable, computed } from 'mobx'
import { CancelProductService } from '../services/CancelProductService'
import filter from 'lodash/filter'

export class CancelProductDataStore {
  private service = new CancelProductService()
  @observable productOrderDetails = null
  @observable isProductOrdersInProgress = false

  @action fetchProductOrderDetails = async (bsgId: string, productId: string) => {
    try {
      this.isProductOrdersInProgress = true
      const productDetails = await this.service.getProductOrderDetails(bsgId, productId)
      if (productDetails) {
        this.productOrderDetails = productDetails
      }
    } finally {
      this.isProductOrdersInProgress = false
    }
  }

  @computed
  get wholesaleOrders() {
    return filter(this.productOrderDetails?.orders || [], { internalClient: false })
  }

  @computed
  get retailOrders() {
    return filter(this.productOrderDetails?.orders || [] || [], { internalClient: true })
  }

  @action markCancelReplaceProduct = async (
    bsgId: string,
    productId: string,
    clientOrderIds: Array<string>,
    doorOrderIds: Array<string>,
    sendNotification: boolean
  ) => {
    await this.service.markCancelReplaceProduct(
      bsgId,
      productId,
      clientOrderIds,
      doorOrderIds,
      sendNotification
    )
  }
}
